export default function useInIframe() {
  return window.self !== window.top;
}
